<template>
  <by-container :showLoading="showLoading" :showNotContent="showNotContent">
    <div class="wrap clearfloat">
      <div class="detailW">
        <div class="detailHead">
          <h2>{{detail.title}}</h2>
          <p>
            <em>时间：{{detail.createTime}}</em>
            <em>浏览量：{{detail.pageViews}}</em>
          </p>
        </div>
        <div class="detailCont" v-html="detail.content">
          <!-- <p>
						以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。
					</p>
					<div class="pic"><img style="height: 200px;" src="/static/img/news/1.jpg"/></div>
					<p>
						以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。
					</p>
					<p>
						以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。
					</p>
					<div class="pic"><img style="height: 200px;" src="/static/img/news/1.jpg"/></div>
					<p>
						以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。以先进文化整合制度体系结合管理体制、组织形式、队伍结构的新变化，推进制度创新、及时修订、完善各种规章制度，逐步建立起与集团文化相适应、相配套的管理体系
						，以健全完善的制度规范企业和职工的行为。
          </p>-->
        </div>
      </div>
    </div>
  </by-container>
</template>

<script>
export default {
  components: {
    // 引入组件
  },
  data() {
    return {
      showLoading: false, //页面加载状态
      showNotContent: false, //是否显示空

      detail: {},
    };
  },
  props: {
    // 上级页面传递的数据
  },
  computed: {
    // 计算属性
  },
  created() {
    // 实例初始化
    if (this.$route.query.status && this.$route.query.status != '') {
			this.getTrainDetail()
    } else {
      this.getNoticeDetail();
    }
  },
  beforeCreate() {
    // 实例初始化之后
  },
  mounted() {
    // 实例被挂载后调用
  },
  updated() {
    // 数据更新后调用
  },
  activated() {
    // 缓存页面显示后调用
  },
  deactivated() {
    // 缓存页面隐藏后调用
  },
  methods: {
    // 获取公告类详情
    getNoticeDetail() {
      let reqInfo = {};
      reqInfo.id = this.$route.query.id;
      this.$api.Home.getNoticesDetail(reqInfo, (res) => {
        this.detail = res.data;
      });
    },
    // 获取培训详情
    getTrainDetail() {
      let reqInfo = {};
      reqInfo.id = this.$route.query.id;
      this.$api.Home.getTrainDetail(reqInfo, (res) => {
        this.detail = res.data;
      });
    },
  },
  watch: {
    // 数据监听及回调
    $route() {
    if (this.$route.query.status && this.$route.query.status != '') {
			this.getTrainDetail()
    } else {
      this.getNoticeDetail();
    }
    },
  },
};
</script>

<style scoped="scoped"></style>
